/*
-- THE FOLLOWING TWO FUNCTIONS BELOW (getListLevel & converQuillToHTML) ARE FROM GITHUB PUBLIC ISSUES FORUM FOR QUILL --
-- https://github.com/quilljs/quill/issues/979 --
-- Quill to HTML text does not follow normal HTML list templates hence the conversion function is required for proper display
*/
function getListLevel(el: any) {
    const className = el.className || '0';
    return +className.replace(/[^\d]/g, '');
}

export function convertQuillToHTML(quillHTML: string = '', quillText: string = '') {
    let newContent = quillText;

    if (quillHTML.includes('<ul>') || quillHTML.includes('<ol>')) {
        const tempEl = window.document.createElement('div');
        tempEl.setAttribute('style', 'display: none;');
        tempEl.innerHTML = quillHTML;

        ['ul', 'ol'].forEach((type) => {
            const startTag = `<${type}>`;
            const endTag = `</${type}>`;

            // Grab each list, and work on it in turn
            Array.from(tempEl.querySelectorAll(type)).forEach((outerListEl) => {
                const listChildren = Array.from(outerListEl.children).filter((el) => el.tagName === 'LI');

                let lastLiLevel = 0;
                let currentLiLevel = 0;
                let difference = 0;

                // Now work through each li in this list
                for (let i = 0; i < listChildren.length; i++) {
                    const currentLi = listChildren[i];
                    lastLiLevel = currentLiLevel;
                    currentLiLevel = getListLevel(currentLi);
                    difference = currentLiLevel - lastLiLevel;

                    if (type === 'ol' && !currentLi.className.includes('level-')) {
                        // calculate the indentation level so that we can do ol indents from 1. -> a. -> i. -> restart from 1.
                        const indentationLevelStr = currentLi.className ? currentLi.className.split('ql-indent-')[1] : '0';
                        const indentationLevel = Number(indentationLevelStr);
                        const indentationClassLevel = indentationLevel % 3;
                        currentLi.className += ` level-${indentationClassLevel}`;
                    }

                    // we only need to add tags if the level is changing
                    if (difference > 0) {

                        // going down the multilayer list level (parent list -> sublist)
                        currentLi.before((startTag).repeat(difference));
                    } else if (difference < 0) {

                        // climbing up the multilayer list level (sublist -> parent list)
                        currentLi.before((endTag).repeat(-difference));
                    }

                    if (i === listChildren.length - 1) {

                        // from the last LI child element, repeatedly close the list
                        // with the appropriate tags until you are at the root level
                        currentLi.after((endTag).repeat(currentLiLevel));
                    }
                }
            });
        });

        //  Get the content in the element and replace the temporary tags with new ones
        newContent = tempEl.innerHTML;
        newContent = newContent.replace(/(&lt;)/g, '<');
        newContent = newContent.replace(/(&gt;)/g, '>');
        newContent = newContent.split('<p><br></p>').join('<br>');

        tempEl.remove();
    }

    return newContent;
}
